import { index, post, put } from "src/api/uom";
import BrandForm from "src/modules/brand/components/BrandForm.vue";

const getInitialState = () => {
  return {
    uoms: [],
    uom: {},
  };
};

export const useUomStore = defineStore("uom", () => {
  const formState = ref({
    edit: false,
    open: false,
  });

  const toggleUomForm = (state = {}) => {
    state = { edit: false, open: !formState.value.open, ...state };

    const { toggleRightDrawer } = useAppStore();

    toggleRightDrawer(state.open, BrandForm);

    formState.value = state;
  };

  let state = reactive(getInitialState());

  const getUom = (id) => {
    state.uom = state.uoms?.find((uom) => uom._id === id);
  };

  const { filter, pagination, params } = usePagination();

  const getUoms = async () => {
    try {
      const response = await index({ params: unref(params) });

      state.uoms = response.data?.data?.data;

      pagination.value.rowsNumber = response.data?.data?.count;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const postUom = async (uom) => {
    try {
      const response = await post(uom);

      await getUoms();

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const putUom = async (uom) => {
    try {
      const response = await put(uom);

      state.uom = response.data;

      return response;
    } catch (error) {
      console.error(error);

      throw error;
    }
  };

  const reset = () => {
    Object.assign(state, getInitialState());
  };

  return {
    formState,
    toggleUomForm,

    filter,
    pagination,

    ...toRefs(state),

    getUom,
    getUoms,
    postUom,
    putUom,

    reset,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUomStore, import.meta.houom));
}
